import initSwiper from './modules/swiper.es6.js';

(() => {
  initSwiper();
})();
